import { captureException, withScope } from "~/observability";

// A module we can do without: loaded on first use, memoized, and degrading to null rather than
// throwing. Used for dependencies that must stay OUT of an entry chunk — see `~/util/remend`.
//
// Takes a THUNK, never a module specifier. `import(someVariable)` is opaque to Rollup, so the
// module gets folded back into the importing chunk and the laziness is silently lost. The
// `import()` call has to stay a literal inside the caller.
export function lazyOptional<T>(
  load: () => Promise<T>,
  fingerprint: string,
): () => Promise<T | null> {
  let pending: Promise<T | null> | null = null;
  return () =>
    (pending ??= load().catch((error: unknown) => {
      withScope((scope) => {
        scope.setFingerprint([fingerprint]);
        captureException(error);
      });
      return null;
    }));
}
